<template>
  <b-row>
    <div
      id="loadingmessage"
      style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
      v-if="loading"
    >
      <p style="position: absolute; color: White; top: 40%; left: 50%;">
        <img src="../../assets/loader.gif" />
      </p>
    </div>

    <b-input-group prepend="Search key" class="mt-3 px-3 pb-4">
      <b-form-input v-model="keyword" placeholder="Please Enter Name or Username...."></b-form-input>
      <b-input-group-append>
        <b-button variant="info">
          <i class="fa fa-search"></i>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <div slot="header" v-html="caption"></div>
          <div v-if="data.length > 0">
            <b-table
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive="sm"
              :items="data"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              class="table-responsive cntus"
            >
              <template id="pdcy" slot="photo" slot-scope="item" style="text-align:center;">
                <img
                  v-if="item.item.photo!=null"
                  v-bind:src="'http://13.232.14.77/u/'+item.item.photo"
                  width="50px"
                  height="50px"
                />
                <p v-else>No Image</p>
              </template>
              <template slot="_id" slot-scope="data">
                <!-- <span style="padding-left:20px!important;">
                  <router-link :to="'/turtleDetails/'+data.item._id ">
                    <b-button variant="success">View Details</b-button>
                  </router-link>
                </span>-->
                <span style="padding-left:20px!important;">
                  <router-link :to="'/edituser/'+data.item._id ">
                    <b-button class="text-white" variant="info">
                      <i class="fa fa-edit"></i>
                    </b-button>
                  </router-link>
                </span>
                <span style="padding-left:20px!important;">
                  <b-button variant="danger" @click="deluser(data.item._id)">
                    <i class="fa fa-trash"></i>
                  </b-button>
                </span>
              </template>
            </b-table>
            <nav>
              <b-pagination
                size="sm"
                :total-rows="getRowCount(data)"
                :per-page="perPage"
                v-model="currentPage"
                prev-text="Prev"
                next-text="Next"
                hide-goto-end-buttons
              />
            </nav>
          </div>
          <div v-else>
            <p>No List Found</p>
          </div>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  name: "Users",
  props: {
    caption: {
      type: String,
      default: "List of Users"
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      items: [],
      type: localStorage.getItem("type"),
      errors: [],
      data: [],
      fields: [
        {
          key: "name",
          label: "Name",
          sortable: true,
          thClass: " cntus",
          tdClass: "cntus"
        },
        {
          key: "email",
          label: "Email",
          sortable: false,
          thClass: " cntus",
          tdClass: "cntus"
        },
        {
          key: "phone",
          label: "Mobile",
          sortable: false,
          thClass: " cntus",
          tdClass: "cntus "
        },
        {
          key: "organization",
          label: "Organization",
          sortable: false,
          thClass: " cntus",
          tdClass: "cntus we"
        },
          {
          key: "state",
          label: "State",
          sortable: false,
          thClass: " cntus",
          tdClass: "cntus we"
        },
        {
          key: "username",
          label: "Username",
          sortable: false,
          thClass: " cntus",
          tdClass: "cntus "
        },
        {
          key: "photo",
          label: "Profile Pic",
          sortable: false,
          thClass: " cntus",
          tdClass: "cntus-"
        },
         {
          key: "_createdAt",
          label: "Created on",
          sortable: true,
          thClass: " cnt",
          tdClass: "cnt ",
        },
        {
          label: " Action",
          key: "_id",
          sortable: false,
          thClass: "cntus",
          tdClass: "cntus we2 "
        }
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      loading: false,
      keyword: ""
    };
  },
  mounted: function() {
    this.getList();
    this.search();
  },
  watch: {
    keyword: function() {
      this.search();
    }
  },
  methods: {
    deluser(val) {
      this.loading = true;
      if (confirm("Are you sure?")) {
        this.loading = true;
        var data1 = {};
        data1["id"] = val;
        data1["x-auth-token"] = localStorage.getItem("token");
        // data1["type"]='admin'
        axios({
          method: "POST",
          data: data1,
          url: "/user/removeuser/"
        })
          .then(response => {
            this.loading = false;
            if (response.data.status) {
              this.getList();
              this.msg = response.data.msg;
            } else {
              this.loading = false;
              this.$router.push({ name: "userlist" });
            }
          })
          .catch(err => {
            this.loading = false;
            this.errors.push(err);
            this.$router.push({ name: "userlist" });
          });
      }
      else
      this.getList()
    },
    getList() {
      this.loading = true;

      axios({
        method: "GET",
        url: "/user/allUsers?type=User&count=0&page=0",
         params:{'type':'user','token':localStorage.getItem("token")},
        // headers: {
        //   "x-auth-token": localStorage.getItem("token")
        // }
      })
        .then(response => {
          this.loading = false;

          if (response.data.status === true) {
            this.data = response.data.data;
               for (var i = 0; i < this.data.length; i++) {
              var dt = this.data[i]._createdAt.slice(0,10);
              
              this.data[i]._createdAt = dt;
              console.log(this.data[i]._createdAt)
            }
            this.loading = false;
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch(e => {
          this.loading = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },
    search() {
      this.visible = true;
      var data1 = {};

      data1["keyword"] = this.keyword;
      data1["x-auth-token"] = localStorage.getItem("token");
      axios({
        method: "GET",
        url: "/user/search?type=User&count=0&page=0",
        params:{'keyword':this.keyword,'token':localStorage.getItem("token")},
      })
        .then(response => {
          for (var i = 0; i < this.data.length; i++) {
            var dt = this.data[i].create_date;
            dt = new Date(dt);
            dt = dt.toString();
            dt = dt.slice(0, 15);
            this.data[i].create_date = dt;
          }
          if (response.data.status === true) {
            this.data = response.data.data;
            this.visible = false;
          } else if (response.data.status === false) {
            this.visible = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.visible = false;
          // this.errors.push(e)
          this.msg = "failed";
        });
    },

    getBadge(status) {
      return status === "sucess"
        ? "success"
        : status === "initiate"
        ? "secondary"
        : status === "progress"
        ? "warning"
        : status === "failure"
        ? "danger"
        : "primary";
    },
    getRowCount(data) {
      return data.length;
    }
    // userLink(id) {
    //   return `users/${id.toString()}`;
    // },
    // rowClicked(data) {
    //   const userLink = this.userLink(data._id);
    //   this.$router.push({ path: userLink });
    // }
  }
};
</script>

<style >
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.cntus {
  text-align: center !important;
}
.we {
  width: 80px !important;
}
.we2 {
  min-width: 200px !important;
}
</style>
